/** @format */
import { css } from 'styled-components';

export const DEFAULT_TEST_ID = 'product-add-to-quote-link';
export const SKELETON_DEFAULT_TEST_ID = `${DEFAULT_TEST_ID}-skeleton`;

export const TRADE_ARROW_TRANSFORM: Record<
    string,
    Record<'from' | 'to', ReturnType<typeof css>>
> = {
    top: {
        from: css`
            transform: translate(0, -0.25em);
        `,
        to: css`
            transform: translate(1em, -0.25em);
        `,
    },
    topHidden: {
        from: css`
            transform: translate(-1em, -0.25em);
        `,
        to: css`
            transform: translate(0, -0.25em);
        `,
    },
    bottom: {
        from: css`
            transform: translate(0, 0.25em) rotate(180deg);
        `,
        to: css`
            transform: translate(-1em, 0.25em) rotate(180deg);
        `,
    },
    bottomHidden: {
        from: css`
            transform: translate(1em, 0.25em) rotate(180deg);
        `,
        to: css`
            transform: translate(0, 0.25em) rotate(180deg);
        `,
    },
};
